import DocumentationButton from "components/DocumentationButton";
import { EmptystateKeyColored } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import Tooltip from "ds/components/Tooltip";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getDocsUrl } from "utils/getDocsUrl";

import useApiKeysCreateAccess from "../useCreateAccess";

const API_KEYS_DOCS_URL = getDocsUrl("/integrations/api#authenticating-with-the-graphql-api");

const ApiKeysEmpty = () => {
  const { canCreateApiKeys, isCreateDisabled, createDisabledTooltip } = useApiKeysCreateAccess();

  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="No organization API keys yet"
        icon={EmptystateKeyColored}
        caption="Organization API keys belong to the organization, not a single user, so they keep working if their creator leaves. Use them for CI, automation and integrations. For your own scripts and spacectl, create a personal API key instead."
      >
        <Box gap="medium">
          {canCreateApiKeys && (
            <Tooltip
              active={isCreateDisabled}
              on={(tooltipProps) => (
                <LinkButton
                  {...tooltipProps}
                  to="/settings/new/api-key"
                  variant="primary"
                  disabled={isCreateDisabled}
                  analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
                  analyticsTitle="Create Key"
                >
                  Create API key
                </LinkButton>
              )}
            >
              {createDisabledTooltip}
            </Tooltip>
          )}
          <DocumentationButton
            to={API_KEYS_DOCS_URL}
            label="Documentation"
            analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
          />
        </Box>
      </EmptyState>
    </Box>
  );
};

export default ApiKeysEmpty;
